var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",style:({'min-height': _vm.docHt + 'px'})},[_c('div',{staticClass:"msg"},[_vm._v("支付成功")]),_vm._v(" "),_c('div',{staticClass:"confirm-btn",on:{"click":_vm.toJump}},[_vm._v("确认")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8450abc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/distribution/pay-success.vue
// module id = null
// module chunks = 